import { supabase } from "@/integrations/supabase/client";

/**
 * Live monthly wager pulled straight from the Rainbet affiliate API, matched on the
 * user's saved Rainbet ID. Returns null when the user has no Rainbet ID saved, the
 * account isn't found under our affiliate code, or the API is unavailable.
 */
export async function fetchRainbetApiWager(): Promise<number | null> {
  try {
    const { data, error } = await supabase.functions.invoke("rainbet-my-wager");
    if (error) throw error;
    if (!data || data.verified !== true) return null;
    return Number(data.wagered ?? 0);
  } catch (err) {
    console.warn("rainbet-my-wager unavailable:", err);
    return null;
  }
}

/**
 * Returns the signed-in user's current monthly Rainbet wager.
 *
 * Source of truth is the Rainbet affiliate API (matched on the user's saved
 * Rainbet ID). The legacy scraped total is only used when the API can't
 * identify the user at all (no Rainbet ID linked / account not under our code).
 */
export async function fetchMyMonthlyWager(): Promise<number> {
  const apiWager = await fetchRainbetApiWager();
  if (apiWager !== null) return apiWager;

  const { data, error } = await supabase.rpc("get_my_monthly_wager" as any);
  if (error) {
    console.error("get_my_monthly_wager failed:", error);
    return 0;
  }
  return Number(data ?? 0);
}
